import { gmapApi } from 'vue2-google-maps'

export default {
  name: 'wmts-layer',
  inject: {
    $mapPromise: {
      default: null
    }
  },
  props: {
    layer: {
      type: Object,
      required: true
    },
    zIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      tileLayer: null,
      mapObject: null
    }
  },
  computed: {
    google: gmapApi,
    currentOpacity() {
      const layerId = this.layer.layer;
      if (this.$store && this.$store.state.ui && this.$store.state.ui.layers_opacities && layerId) {
        return this.$store.state.ui.layers_opacities[layerId] || 35;
      }
      return typeof this.layer.opacity === 'number' ? this.layer.opacity : 35;
    }
  },
  mounted() {
    this.$mapPromise.then(map => {
      this.mapObject = map
      this.createTileLayer()
    })
  },
  beforeDestroy() {
    if (this.tileLayer && this.mapObject) {
      // Trouver l'index du tileLayer et le supprimer
      const overlays = this.mapObject.overlayMapTypes
      for (let i = 0; i < overlays.getLength(); i++) {
        if (overlays.getAt(i) === this.tileLayer) {
          overlays.removeAt(i)
          break
        }
      }
    }
  },
  watch: {
    currentOpacity(newVal) {
      if (this.tileLayer) {
        this.tileLayer.setOpacity(newVal/100)
      }
    }
  },
  methods: {
    createTileLayer() {

      this.$store.dispatch('layer_loaded', this.layer.layer);
      
      if (!this.mapObject || !this.google) {
        console.error('Google Maps instance not available')
        return
      }

      try {
        const getTileUrl = (coord, zoom) => {
          return this.layer.url
            .replace('{zoom}', zoom)
            .replace('{x}', coord.x)
            .replace('{y}', coord.y)
        }

        const options = {
          getTileUrl,
          tileSize: new this.google.maps.Size(256, 256),
          opacity: this.currentOpacity/100
        }

        this.tileLayer = new this.google.maps.ImageMapType(options)

        // Le zIndex n'est pas disponible sur les overlayMapTypes, on doit donc le calculer et jouer avec les index
        const zIndex = this.mapObject.overlayMapTypes.getLength();
        this.mapObject.overlayMapTypes.insertAt(zIndex, this.tileLayer)
      } catch (error) {
        console.error('Error creating tile layer:', error)
      }
    }
  },
  render() {
    return null // Ce composant ne rend aucun élément DOM
  }
}
